export default {
  async loadDeviceList (state) {
    const deviceList = await this.$axios.$get("/inventur/getIDs");
    state.commit('setDeviceList', deviceList);
  },
};